export default "__VITE_ASSET__CDmDPegp__"